import type { ConversationSummary } from '@dermalink/shared';
import { deletionCountdownLabel } from '@/utils';

const AVATAR_PALETTES = [
  { bg: '#ffd5be', color: '#b86b45' },
  { bg: '#e8c9a8', color: '#966b3e' },
  { bg: '#fac6be', color: '#c45c4e' },
  { bg: '#f0d4b8', color: '#a06438' },
] as const;

export function avatarPalette(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) & 0xffff;
  return AVATAR_PALETTES[hash % AVATAR_PALETTES.length];
}

function compactAge(value: string): string {
  const created = new Date(value).getTime();
  const now = Date.now();
  const diffMs = Math.max(0, now - created);
  const totalHours = Math.floor(diffMs / (1000 * 60 * 60));
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  if (days > 0) return `${days}d ${hours}u`;
  if (hours > 0) return `${hours}u`;
  const minutes = Math.max(1, Math.floor(diffMs / (1000 * 60)));
  return `${minutes}m`;
}

export function conversationDisplayName(conv: ConversationSummary): string {
  return conv.subject_first_name && conv.subject_last_name
    ? `${conv.subject_first_name} ${conv.subject_last_name}`
    : conv.patient_name;
}

export function conversationTimeLabel(conv: ConversationSummary): string {
  return conv.status === 'closed'
    ? `wordt gewist binnen ${deletionCountdownLabel(conv.updated_at)}`
    : `gestart ${compactAge(conv.created_at)} geleden`;
}
